<template>
  <div id="app">
    <router-view/>
    <div class="user-notice_root" v-show="showNotice">
      <div class="header">
        <span class="title">消息</span>
        <span class="icon icon el-icon-close" @click="know"></span>
      </div>
      <div class="notice_main app_notice">
        <vue-scroll :ops="vuescrollOpt">
          <div class="notice_list">
            <div class="notice_item" v-for="(notice, i) in getStoreNotice" :key="notice.notification_id">
              <div class="notice_header">
                <p class="title">{{notice.title}}</p>
                <i :class="['el-icon-arrow-down', 'icon', foldArr[i] ? '':'trans']" @click.stop="foldNotice(i)"></i>
              </div>
              <div class="notice_info" v-show="foldArr[i]">
                <div class="ql-container ql-snow">
                  <div class="ql-editor" v-html="notice.content"></div>
                </div>
                <div class="author">{{notice.expediter}}</div>
                <div class="author">{{notice.create_time | time}}</div>
              </div>
            </div>
          </div>
        </vue-scroll>
      </div>
      <!-- <div class="notice_footer">
        <el-button type="primary" size="small" @click="know">我知道了</el-button>
      </div> -->
    </div>
    <template v-if="getStoreIsLogin">
<!--      <el-dialog width="350px"-->
<!--                 :show-close="false"-->
<!--                 :close-on-press-escape="false"-->
<!--                 :visible.sync="getStoreIsLogin"-->
<!--                 :close-on-click-modal="false">-->
<!--        <div>当前浏览器已登录过学员账号，禁止一个浏览器登录多个学员账号</div>-->
<!--        <div>-->
<!--          <el-button @click="hideLoginOut">我知道了</el-button>-->
<!--        </div>-->
<!--      </el-dialog>-->
      <yioks-iKnow :showTips="getStoreIsLogin" tips="当前浏览器已登录过学员账号，禁止一个浏览器登录多个学员账号。" @hideTips="hideLoginOut"></yioks-iKnow>
    </template>
  </div>
</template>
<script>
  import createScrollOpt from "@/assets/js/vuescrollOption";
  import "./assets/theme/index.css"; // element-ui配置样式
  import 'vuescroll/dist/vuescroll.css'; // 滚动条样式
  import './assets/css/index.styl'; // 全局样式

  /* 返回箭头 */
  import "vue-awesome/icons/regular/arrow-alt-circle-left";

  import "vue-awesome/icons/qrcode";
  /* 搜索框叉号 */
  import "vue-awesome/icons/regular/times-circle";
  // 编辑图标
  import "vue-awesome/icons/regular/edit";
  import {storageData} from "@/assets/js/storage";
  import { mapMutations, mapGetters  } from "vuex";
  import { knowNotice, pushNotice } from "@/api/notice/notice";
  import {signOut} from "@/api/common/api";
  export default {
    name: "App",
    data() {
      return {
        showNotice: false,
        vuescrollOpt: createScrollOpt(true),
        foldArr: [],
        isLogin:false,
      }
    },
    created() {
      this.$parent.$options.token=storageData.getToken()
      const info = storageData.getUserInfo();
      if(info) {
        this.updateUserInfo(info);
        this.setHeartBeat();
      }
    },
    components:{
      "yioks-iKnow": () => import('@/components/Tips/iKnow'),
    },
    methods: {
      ...mapMutations(["setHeartBeat", "updateUserInfo",'clearHeartBeat']),
      foldNotice(i) {
        this.foldArr.splice(i,1,!this.foldArr[i]);
      },
      know() {
        const notification_ids = this.getStoreNotice.map(({notification_id}) => notification_id);
        knowNotice({ notification_id: notification_ids.join(',')})
        .then(({ data:{status} }) => {
          if (Number(status) === 0) {
            // this.$message.success("操作成功~");
            this.setHeartBeat();
          } else {
          }
        })
        .catch(err => {
          console.error(err);
        });
        this.showNotice = false;
      },
      hideLoginOut(bool, flag) {
          this.clearHeartBeat(); // 清除心跳
          const token = storageData.getToken();
          const userType = storageData.getUserType();
          yioks_vm.$options.token=''
          // 退出登录接口
          signOut({}, token, userType)
                  .catch((err) => {
                    console.error(err);
                  });
          this.$store.commit('updateIsLogin',false)
          storageData.clearUserInfo();
          storageData.clearToken();
          storageData.clearUserType();
          this.$router.replace({
            path: "/login",
            query: {}
          });
      },
    },
    computed: {
      ...mapGetters(['getStoreNotice','getStoreIsLogin']),
    },
    watch: {
      getStoreNotice(newVal, oldVal) {
        if(newVal.length !== oldVal.length) {
          this.foldArr = Array(newVal.length).fill(true)
        }
        this.showNotice = !!newVal.length
      },
    },
  };
</script>
<style lang="stylus">
  html, body, #app {
    height: 100%;
  }
  #app {
    min-width: 1024px;
    /*min-height: 860px;*/
    min-height: 910px;
    background-image: url("~@/assets/images/bgImage.jpg");
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center top;
  }
  .app_notice {
    .notice_info {
      .ql-container {
        border: none;
        height: auto;
        font: inherit;
      }
    }
  }

  /*@media screen and (min-width: 1024px) {
    #app {
      min-height: 910px;
      background-image: url("~@/assets/images/bg_big.jpg");
    }
  }*/
</style>
<style lang="stylus" scoped>
@import '~@/assets/css/variable'
.user-notice_root
  display block
  position fixed
  z-index 99999
  border-radius 10px
  right 6px
  bottom 6px
  width 400px
  background-color $color_white;
  overflow hidden
  .header
    display block
    position relative
    text-align center
    color $color_white
    font-size 18px
    padding 3px 0
    line-height 30px
    background-color $color_suc
    .icon
      position absolute
      top 0
      right 0
      transform translate3d(-50%,50%,0)
  .notice_main
    display block
    padding 5px 0
    width 100%
    height 260px
    overflow hidden
    .notice_list
      display block
      padding 0 15px
      .notice_item
        display block
        margin-bottom 10px
        word-break: break-all;
        word-wrap: break-word;
        .notice_header
          display: flex;
          align-items: center;
          justify-content: space-between;
          font-size: 16px;
          font-weight: bolder;
          padding-bottom: 3px;
          border-bottom: 1px solid #ccc;
          .icon
            padding 3px 5px
          .trans
            transform rotate(180deg)
        .notice_info
          display block
          padding 5px 0
        .author
          text-align right
  .notice_footer
    display block
    padding 5px 0 8px
    text-align center
</style>
<!--！！！！！！！！！！不能删！！！！！！！！！！-->
<!--解决了在edge浏览器下，电脑显示设置大于100%时，eldialog弹窗无法显示完全并且不能点击的bug-->
<!--但是又出现了另外一个问题，讲师简历或者其他页面内容高度超出页面高度时，整体页面中会出现3个滚动条-->
<style lang="stylus">
    html{
      overflow auto
    }
</style>
<style lang="stylus" >
  /* 这里是el-cascader的全局样式，部分样式重写了input的样式 */

  .el-cascader
    cursor pointer
  .el-input
    position relative
    font-size 14px
    display inline-block
    width 100%
  .el-input--suffix .el-input__inner
    padding-right 30px
  .el-cascader-panel
    display flex
    border-radius 4px
    font-size 14px
  .el-cascader-menu
    min-width 180px
    box-sizing border-box
    color #606266
    border-right solid 1px #E4E7ED
    vertical-align top
    height 204px
    background-color #fff
    -webkit-box-sizing border-box
    box-sizing border-box
    margin 0
    padding 6px 0
  .el-scrollbar
    overflow hidden
    position relative
  .el-cascader-menu
    .el-cascader-menu__wrap
      height 204px
      margin-bottom -19px
      margin-right -19px
  .el-cascader__tags .el-tag>span
    -webkit-box-flex 1
    -ms-flex 1
    flex 1
    overflow hidden
    text-overflow ellipsis
  .el-cascader__dropdown
    margin 5px 0
    font-size 14px
    background #FFF
    border 1px solid #E4E7ED
    border-radius 4px
    -webkit-box-shadow 0 2px 12px 0 rgba(0,0,0,.1)
    box-shadow 0 2px 12px 0 rgba(0,0,0,.1)
  .el-cascader-menu__list
    position relative
    min-height 100%
    margin 0
    padding 6px 0
    list-style none
    -webkit-box-sizing border-box
    box-sizing border-box
  .el-cascader-node.in-active-path, .el-cascader-node.is-active, .el-cascader-node.is-selectable.in-checked-path
    color #409EFF
    font-weight 700
  .el-cascader-node
    position relative
    display -webkit-box
    display -ms-flexbox
    display flex
    -webkit-box-align center
    -ms-flex-align center
    align-items center
    padding 0 30px 0 20px
    height 34px
    line-height 34px
    outline 0
  .el-cascader__tags
    position absolute
    left 0
    right 30px
    top 50%
    -webkit-transform translateY(-50%)
    transform translateY(-50%)
    display -webkit-box
    display -ms-flexbox
    display flex
    -ms-flex-wrap wrap
    flex-wrap wrap
    line-height normal
    text-align left
    -webkit-box-sizing border-box
    box-sizing border-box
  .el-tag
    background-color #ecf5ff
    border-color #d9ecff
    display inline-block
    height 32px
    padding 0 10px
    line-height 30px
    font-size 12px
    color #409EFF
    border-width 1px
    border-style solid
    border-radius 4px
    -webkit-box-sizing border-box
    box-sizing border-box
    white-space nowrap

  .el-tag--small
    height 24px
    padding 0 8px
    line-height 22px

  .el-cascader__tags .el-tag
    display -webkit-inline-box
    display -ms-inline-flexbox
    display inline-flex
    -webkit-box-align center
    -ms-flex-align center
    align-items center
    max-width 100%
    margin 2px 0 2px 6px
    text-overflow ellipsis
    background #f0f2f5
  .el-input__inner
    -webkit-appearance none
    background-color #fff
    background-image none
    border-radius 4px
    border 1px solid #dcdfe6
    -webkit-box-sizing border-box
    box-sizing border-box
    color #606266
    display inline-block
    font-size inherit
    height 40px
    line-height 40px
    outline none
    padding 0 15px
    -webkit-transition border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1)
    transition border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1)
    width 100%
  span
    margin 0
    padding 0
    border 0
    font-size 100%
    vertical-align baseline
  .el-tag .el-icon-close
    border-radius 50%
    text-align center
    position: relative
    cursor pointer
    font-size 12px
    height 16px
    width 16px
    line-height 16px
    vertical-align middle
    top -1px
    right -5px
  .el-cascader__search-input
    -webkit-box-flex 1
    -ms-flex 1
    flex 1
    height 24px
    min-width 60px
    margin 2px 0 2px 15px
    padding 0
    /*color #606266*/
    border none
    outline 0
    -webkit-box-sizing border-box
    box-sizing border-box
    color:#c0c4cc !important;
  input::-webkit-input-placeholder
    color #c0c4cc !important
  input::-moz-placeholder
    color #c0c4cc !important
  input:-moz-placeholder
    color #c0c4cc !important
  input:-ms-input-placeholder
    color #c0c4cc !important
</style>
